<!-- 登录 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
		</div>


		<ul class="tab-list">
			<li
          :class="{ active: params.account_type === 2 }"
          @click="params.account_type = 2"
      >
        个人登录
      </li>
			<li
          :class="{ active: params.account_type === 1 }"
          @click="params.account_type = 1"
      >
        企业登录
      </li>
		</ul>

		<div class="form-box">


			<!-- 个人登录 -->
			<div v-if="params.account_type === 2">
				<div class="form-row">
					<input type="text" v-model="params.account" placeholder="请输入手机号码" class="input" />
				</div>

				<div class="form-row">
          <van-field class="input" v-model="params.code" maxlength="6" type="digit" placeholder="请输入验证码"/>
          <button v-if="countDown <= 0" @click="sendSms()" type="button" class="get-btn">获取验证码</button>
          <button v-else type="button" class="get-btn">{{countDown}}秒后重发</button>
				</div>
			</div>
			<!-- 个人登录 -->

			<!-- 企业登录 -->
			<div v-if="params.account_type === 1">
				<div class="form-row">
					<input type="text" v-model="params.account" placeholder="请输入邮箱账号" class="input" />
				</div>

				<div class="form-row">
          <van-field class="input" v-model="params.code" maxlength="6" type="digit" placeholder="请输入邮箱验证码"/>
          <button v-if="countDown <= 0" @click="sendSms()" type="button" class="get-btn">获取验证码</button>
          <button v-else type="button" class="get-btn">{{countDown}}秒后重发</button>
				</div>
			</div>
			<!-- 企业登录 -->

			<div class="bottom-row">
				<a href="javascript:void(0)" @click="selected = !selected">
					<img class="circle-img" v-if="selected" src="../assets/circle-active.png">
					<img class="circle-img" v-else src="../assets/circle.png">
				</a>
				我已阅读并同意
        <span class="blue">
          <span @click="$router.push('/agreement?configKey=agreement')">《用户协议》</span>
          、
          <span @click="$router.push('/agreement?configKey=privacy')">《用户隐私》</span>
        </span>
			</div>

			<div class="btn-box">
				<button type="button" @click="submit()">登录</button>
			</div>

		</div>

	</div>
</template>

<script>
import {ExpediteService, LoginService} from "@/common/service";
  import {Toast} from "vant";
import {getFacilityType, getUniqueCode, isWeChatOpen, validatorFun} from "@/common/util";
import {appid, getCode} from "@/common/wxjssdk.util";

  export default {
		name: 'login',
		components: {},
		data() {
			return {
				selected: false, // 协议

        params: {
          account_type: 2,  // 账号类型 1 企业 2 个人
          account: '',  // 账号
          code: '',  // 验证码
          facility_type: '', // 设备类型 1 安卓手机设备  2 ios手机设备  3 安卓ipad  4 iosipad  5 pc电脑设备号
          facility_code: '', // 设备号, 此处用的浏览器指纹
        },

        countDown: 0,
        loading: false,
			};
		},
    mounted() {
      this.params.facility_type = getFacilityType();
      getUniqueCode().then(facility_code => this.params.facility_code = facility_code);
    },
    methods: {

      submit() {
        if (this.loading) return ;
        this.loading = true;
        const params = this.params;
        const errList = validatorFun(params, [
          ['account', ['notNull', '请输入账户']],
          ['code', ['notNull', '请输入账验证码']],
        ]);
        if (errList.length > 0) {
          this.loading = false;
          return Toast(errList[0].errMsg);
        }
        if (!this.selected) {
          this.loading = false;
          return Toast('请阅读并同意《用户协议》、《用户隐私》');
        }
        LoginService.unifiedLogin(params).then(({ msg, data }) => {
          this.params.code = '';
          Toast(msg);
          setTimeout(() => {
            localStorage.setItem('token', data.token);
            if (isWeChatOpen()) {
              getCode();
            } else {
              this.$router.push('/');
            }
          }, 1000);
        }).finally(() => setTimeout(() => this.loading = false, 1000));
      },
      // 发送验证码
      sendSms() {
        const params = this.params;
        const errList = validatorFun(params, [
          ['account', ['notNull', '请输入账户']],
        ]);
        if (errList.length > 0) {
          return Toast(errList[0].errMsg);
        }
        const reqMap = {
          1: ExpediteService.emailSms,
          2: ExpediteService.sendSms,
        }
        const reqParamsMap = {
          1: { email: params.account },
          2: { phone: params.account },
        }
        reqMap[params.account_type](reqParamsMap[params.account_type]).then(({ msg }) => {
          this.countDownFn();
          Toast(msg);
        });
      },
      countDownFn() {
        let num = 60;
        const fn = () => {
          if (num === 0) return;
          this.countDown = --num;
          setTimeout(() => fn(), 1000);
        };
        fn();
      },
    }
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 129px 30px 30px;
		box-sizing: border-box;
	}

	.tab-list {
		width: 100%;
		white-space: nowrap;
		margin-bottom: 70px;
	}

	.tab-list>li {
		display: inline-block;
		color: #333333;
		font-size: 16px;
		margin-right: 26px;
	}

	.tab-list>li:last-child {
		margin-right: 0;
	}

	.tab-list>li.active {
		font-weight: 500;
		color: #222222;
		font-size: 28px;
	}

	.form-box {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.form-row {
		width: 100%;
		height: 48px;
		display: flex;
		align-items: center;
		background-color: #F5F6F7;
		border-radius: 100px;
		margin-bottom: 20px;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.input {
		flex: 1;
		font-size: 14px;
    background: none;
    padding: 0;
    border: none;
	}

  .input::placeholder,
	.input >>> input::placeholder {
		color: #9C9C9C!important;
	}
  .input::after{
    display: none;
  }

	.get-btn {
		color: #2A63F3;
		font-size: 14px;
	}

	.bottom-row {
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 60px;
		color: #9C9C9C;
		font-size: 12px;
	}

	.circle-img {
		width: 12px;
		margin-right: 6px;
	}

	.blue {
		color: #2A63F3;
	}

	.btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 15px 0;
	}

	.btn-box>button {
		width: 100%;
		height: 48px;
		line-height: 48px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 20px;
		font-weight: 500;
		border-radius: 100px;
		background-color: #2A63F3;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}
</style>
